import { CommunicationWindowSchema, OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES } from 'notable-common';
import { AutomatedVoiceMessageSchema, getAutomatedVoice } from 'primary-schema';
import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowBlockValueUsPhoneNumberSchema } from '../../blockValue/phoneNumberSchema.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowAutomatedVoiceBlockConfigSchema = z
    .object({
    calleePhoneNumber: FlowBlockValueUsPhoneNumberSchema({
        isRequired: true,
        allowedCountries: OUTBOUND_CALL_AND_SMS_ALLOWED_COUNTRIES,
    }),
    callerPhoneNumberId: z.uuid('Must be a valid phone number configuration id.'),
    // Length and character limits apply after templates resolve, so the block checks them when it runs.
    message: z.string().min(1, 'This field is required.'),
    language: AutomatedVoiceMessageSchema.shape.language,
    voice: AutomatedVoiceMessageSchema.shape.voice,
    voiceSpeed: AutomatedVoiceMessageSchema.shape.voiceSpeed,
    voicemailAction: AutomatedVoiceMessageSchema.shape.voicemailAction,
    timeout: FlowDurationSchemaWithMax({
        pathName: 'value',
        max: { value: 60, units: FlowDurationUnits.Minutes },
    }),
    communicationWindow: CommunicationWindowSchema.optional(),
})
    .refine((config) => getAutomatedVoice(config).locale.startsWith(`${config.language}-`), {
    message: 'Select a voice for the configured language.',
    path: ['voice'],
});
export const FlowAutomatedVoiceBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.AutomatedVoice),
    config: FlowAutomatedVoiceBlockConfigSchema,
});
//# sourceMappingURL=config.js.map